import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Barcode } from "@phosphor-icons/react";

/**
 * Barcode input for the Add/Edit Menu Item forms. Accepts a scanner
 * feed (which acts as a keyboard) or manual typing, and offers a
 * "Generate" button that produces a random 12-digit numeric code.
 *
 * The generated format is deliberately UPC-A-length (12 digits) so it
 * stays broadly compatible with legacy scanners without needing a
 * real check digit — barcodes are only used as internal keys, not for
 * regulated retail scanning.
 */
const generate12Digit = () => {
  // 12 random digits, first char never 0 for a clean look
  let s = String(1 + Math.floor(Math.random() * 9));
  for (let i = 0; i < 11; i++) s += Math.floor(Math.random() * 10);
  return s;
};

const BarcodeField = ({ value, onChange, testIdPrefix = "menu-barcode" }) => (
  <div className="space-y-2">
    <Label className="flex items-center gap-2">
      <Barcode size={16} /> Barcode <span className="text-xs text-muted-foreground font-normal">(optional)</span>
    </Label>
    <div className="flex gap-2">
      <Input
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Scan a barcode or click Generate"
        className="font-mono"
        data-testid={`${testIdPrefix}-input`}
      />
      <Button
        type="button"
        variant="outline"
        onClick={() => onChange(generate12Digit())}
        data-testid={`${testIdPrefix}-generate`}
      >
        Generate
      </Button>
      {value ? (
        <Button
          type="button"
          variant="ghost"
          onClick={() => onChange("")}
          data-testid={`${testIdPrefix}-clear`}
          title="Clear barcode"
        >
          Clear
        </Button>
      ) : null}
    </div>
    <p className="text-xs text-muted-foreground">
      Scanners act as keyboards — focus this field and scan. Must be unique across menu items.
    </p>
  </div>
);

export default BarcodeField;
